export function BackToTopBar() {
  return (
    <button
      type="button"
      id="back-to-top"
      className="kmart-back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
    >
      Back to top
    </button>
  );
}
